import { Link, useParams, Navigate } from "react-router-dom";
import { ArrowUpRight, ArrowLeft } from "lucide-react";
import { Reveal } from "../components/Reveal";
import Seo from "../components/Seo";
import { POSTS } from "../data/blog";

export default function BlogPost() {
  const { slug } = useParams();
  const post = POSTS.find((p) => p.slug === slug);
  if (!post) return <Navigate to="/blog" replace />;

  return (
    <div data-testid="blog-post-page" className="pt-32 md:pt-44">
      <Seo
        title={`${post.metaTitle || post.title} | Quexify`}
        description={post.metaDescription || post.excerpt}
        path={`/blog/${post.slug}`}
      />
      <article className="max-w-[820px] mx-auto px-6 md:px-10">
        <Reveal>
          <Link to="/blog" className="inline-flex items-center gap-2 text-neutral-500 hover:text-black transition-colors mb-10" data-testid="back-to-blog">
            <ArrowLeft size={18} /> Journal
          </Link>
          <h1 className="font-display text-4xl md:text-6xl tracking-tighter font-medium leading-[0.98]">{post.title}</h1>
          <p className="mt-8 text-xl text-neutral-500 leading-relaxed">{post.excerpt}</p>
        </Reveal>

        <div className="mt-16 md:mt-20 space-y-16">
          {post.sections.map((s, i) => (
            <Reveal key={i} delay={0.03}>
              <section>
                <h2 className="font-display text-2xl md:text-3xl tracking-tight font-medium mb-6">{s.h2}</h2>
                {s.body && s.body.map((p, j) => (
                  <p key={j} className="text-lg text-neutral-600 leading-relaxed mb-5">{p}</p>
                ))}
                {s.table && (
                  <div className="my-8 overflow-x-auto rounded-2xl border border-black/10">
                    <table className="w-full text-left text-sm md:text-base">
                      <thead>
                        <tr className="bg-[#fafafa] border-b border-black/10">
                          {s.table.head.map((h, k) => (
                            <th key={k} className="p-4 font-display font-medium tracking-tight">{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {s.table.rows.map((row, r) => (
                          <tr key={r} className="border-b border-black/5 last:border-0">
                            {row.map((cell, c) => (
                              <td key={c} className={`p-4 ${c === 0 ? "font-medium text-black" : "text-neutral-600"}`}>{cell}</td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </section>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="mt-20 mb-24 md:mb-40 rounded-3xl bg-[#0a0a0a] text-white px-8 md:px-14 py-14 text-center">
            <h2 className="font-display text-3xl md:text-4xl tracking-tighter font-medium">Book a discovery call with Quexify.</h2>
            <Link to="/book-demo" className="mt-8 inline-flex items-center gap-2 rounded-full bg-white text-black px-8 py-4 text-lg transition-transform duration-300 hover:-translate-y-0.5" data-testid="blog-cta">
              Book a discovery call <ArrowUpRight size={20} />
            </Link>
          </div>
        </Reveal>
      </article>
    </div>
  );
}
